module.exports = __webpack_public_path__ + "static/cf-reg-ext-fa64e5598042ee54836023ca1c698c37.ttf";